import { render, staticRenderFns } from "./RegisterEntry.yaml?vue&type=template&id=48b343a2&component"
import script from "./RegisterEntry.yaml?vue&type=script&lang=ts&component"
export * from "./RegisterEntry.yaml?vue&type=script&lang=ts&component"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports